module.exports = __webpack_public_path__ + "static/media/menu.4f2c4440.svg";